"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomain = exports.getWebsiteGrade = void 0;

var getWebsiteGrade = function getWebsiteGrade(state) {
  return state.grader;
};

exports.getWebsiteGrade = getWebsiteGrade;

var getDomain = function getDomain(state) {
  return getWebsiteGrade(state).get('domain');
};

exports.getDomain = getDomain;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/Grader.js
// module id = 96
// module chunks = 0